export default __webpack_public_path__ + "static/profilbg-e8eec46f34ad1fe50ec567a8ed87892a.png";